import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoadingModule } from '@merchant-portal/app/components/loading/loading.module';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { BreadcrumbComponent } from 'projects/merchant-portal/src/app/components/breadcrumb/breadcrumb.component';
import { CoreModule } from 'projects/merchant-portal/src/app/core/core.module';
import { BatchDetailModule } from './batch-detail/batch-detail.module';
import { BatchPreviewModule } from './batch-preview/batch-preview.module';
import { BulkTransactionComponent } from './bulk-transaction.component';
import { BulkTransactionRoutingModule } from './bulk-transaction.routing.module';
import { BulkTransactionApiFatoryService } from './factory/bulk-transaction-api-factory.service';
import { BulkTransactionFactoryService } from './factory/bulk-transaction-store-factory';
import { NewBatchModule } from './new-batch/new-batch.module';
import { BulkTransactionApiService } from './services/bulk-transaction.api.service';
import { BulkTransactionService } from './services/bulk-transaction.service';

@NgModule({
  declarations: [BulkTransactionComponent],
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    DatePickerModule,
    CoreModule,
    FormsModule,
    InputTextModule,
    SelectModule,
    PaginatorModule,
    BulkTransactionRoutingModule,
    BreadcrumbComponent,
    NewBatchModule,
    BatchPreviewModule,
    BatchDetailModule,
    LoadingModule,
  ],
  providers: [
    {
      provide: BulkTransactionFactoryService,
      useClass: BulkTransactionService,
    },
    {
      provide: BulkTransactionApiFatoryService,
      useClass: BulkTransactionApiService,
    },
  ],
})
export class BulkTransactionModule {}
